export const URL = {
	BASE: process.env.REACT_APP_ENDPOINT,
	VACACIONES: process.env.REACT_APP_ENDPOINT_VACACIONES,
	RECLUTAMIENTO_Y_SELECCION: process.env.REACT_APP_ENDPOINT_RECLUTAMIENTO_Y_SELECCION,
};
